import { useQuery } from '@tanstack/react-query';

import decodeJson from '@seccon/shared/utils/decodeJson';
import ApiError from '@seccon/shared/utils/ApiError';

const EMPTY_ARRAY = [];

/**
 * Fetches the contract information
 * @param {} context - react query context
 * @returns {Promise<object>} - CurrentUser information
 */

function fetchCognizantOffice () {
  return fetch('/cognizantSecurityAuthority/getDropdownList')
    .then(decodeJson)
    .catch(({ body, status }) => {
      if (status === 404) {
        throw new ApiError('Unable to get the cognizant office');
      }
      throw new ApiError(body ? `Error: ${ body }` : 'Unable to retrieve the cognizant office. Please reload the page and try again');
    });
}

const useCognizantOffice = (shouldLoad) => {
  const { data } = useQuery({
    queryKey: ['useCongnizantOffice'],
    queryFn: fetchCognizantOffice,
    refetchOnWindowFocus: false,
    enabled: shouldLoad,
    staleTime: Infinity
  });

  return data ?? EMPTY_ARRAY;
};

export default useCognizantOffice;
